import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { forwardRef } from "react";
import Textarea from "react-expanding-textarea";
const TextAreaStyle = `
  appearance-none
  shadow-none
  rounded-md
  border-1
  border-white
  border-opacity-10
  focus:ring-1
  focus:border-white
  focus:border-opacity-25
  mb-3
  bg-grayscale-light
  py-2
  px-3
  w-full
  text-white
`;
const TextAreaDisabledStyles = `
  text-grayscale-lightest
  cursor-not-allowed
`;
const STextarea = /*#__PURE__*/ forwardRef(({ disabled, rows = 3, placeholder, value, isError = false, onChange, onFocus, onBlur, className, autoFocus, ...props }, ref)=>{
    return /*#__PURE__*/ _jsx(Textarea, {
        className: `${TextAreaStyle} ${disabled && TextAreaDisabledStyles} ${className || ""}`,
        disabled: disabled,
        placeholder: placeholder,
        rows: rows,
        ref: ref,
        autoFocus: autoFocus,
        onChange: onChange,
        value: value,
        onFocus: onFocus,
        onBlur: onBlur,
        style: isError ? {
            borderColor: "#ff3c3c"
        } : {}
    });
});
STextarea.displayName = "STextarea";
export default STextarea;
